import { render, staticRenderFns } from "./deptTutorialsdata.vue?vue&type=template&id=5828b007&scoped=true"
import script from "./deptTutorialsdata.vue?vue&type=script&lang=js"
export * from "./deptTutorialsdata.vue?vue&type=script&lang=js"
import style0 from "./deptTutorialsdata.vue?vue&type=style&index=0&id=5828b007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828b007",
  null
  
)

export default component.exports